module.exports = __webpack_public_path__ + "img/step_img_04.6d4be62f.webp";